import { Fragment } from 'react';
import type { ProjectGraphDocumentFacts } from '@avisoma/shared';

/** A document's facts card: the one-sentence summary, then its label/value facts. */
export function DocumentFacts({ facts }: { facts: ProjectGraphDocumentFacts }) {
  return (
    <>
      <p className="text-zinc-600 dark:text-zinc-300">{facts.what}</p>
      <dl className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-0.5 text-sm">
        {facts.facts.map(({ label, value }) => (
          <Fragment key={label}>
            <dt className="text-zinc-500 dark:text-zinc-400">{label}</dt>
            <dd className="min-w-0 break-words">{value}</dd>
          </Fragment>
        ))}
      </dl>
    </>
  );
}
